<template>
  <v-flex
    xs12
  >
    <promote-post-top-block
      :reviewFileUrl="message.reviewFileUrl"
      @setReviewFileUrl="setReviewFileUrl"
      @clearReviewFileUrl="clearReviewFileUrl"
      @setMessageFields="setMessageFields"
    />
    <create-ad-preview-block
      :reviewFileUrl="message.reviewFileUrl"
      :text="message.text"
      :headline="message.headline"
      :displayLink="message.displayLink"
      :description="message.description"
      :preview="message.preview"
      :previewLoading="message.previewLoading"
      :callToAction="message.callToAction"
      @setMessageFields="setMessageFields"
      @setConfirmActive="setConfirmActive"
    />
    <create-ad-tracking-block
      :name="message.name"
      @setMessageFields="setMessageFields"
    />
  </v-flex>
</template>

<script>
import PromotePostTopBlock from './PromotePostTopBlock.vue'
import CreateAdPreviewBlock from './CreateAdPreviewBlock.vue'
import CreateAdTrackingBlock from './CreateAdTrackingBlock.vue'
export default {
  name: 'MessagesPromotePost',
  components: {
    PromotePostTopBlock,
    CreateAdPreviewBlock,
    CreateAdTrackingBlock
  },
  computed: {
    scraper () {
      return this.$store.getters.getScraperData
    }
  },
  props: {
    selectedIssue: {
      type: Object,
      default: () => {}
    },
    message: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    this.createBreadcrumbs()
  },
  methods: {
    createBreadcrumbs () {
      let breadcrumbs = [
        {
          text: this.selectedIssue.name,
          disabled: true
        },
        {
          text: 'Ad 1',
          disabled: true
        },
        {
          text: 'Promote a post',
          disabled: true
        }
      ]
      this.$emit('setBreadcrumbs', breadcrumbs)
    },
    setReviewFileUrl (url, file, preview) {
      this.$emit('setMessageFields', url, 'reviewFileUrl')
      this.$emit('setMessageFields', null, 'externalUrl')
      this.$emit('setMessageFields', file, 'file', preview)
    },
    clearReviewFileUrl () {
      this.$emit('setMessageFields', null, 'reviewFileUrl')
      this.$emit('setMessageFields', null, 'externalUrl')
      this.$emit('setMessageFields', null, 'file', true)
    },
    setConfirmActive (status) {
      this.$emit('setConfirmActive', status, true)
    },
    setMessageFields (value, field, preview) {
      this.$emit('setMessageFields', value, field, preview)
    }
  },
  watch: {
    scraper (val) {
      if (val) {
        this.$emit('setMessageFields', val.image, 'externalUrl')
        this.$emit('setMessageFields', null, 'reviewFileUrl')
        this.$emit('setMessageFields', val.description, 'text')
        this.$emit('setMessageFields', val.title, 'headline', true)
      }
    }
  }
}
</script>
